// ABOUTME: Client-side providers wrapper for identity and session refresh.
// ABOUTME: Wraps children in @zapier/identity IdentityProvider + SessionProvider.
"use client";

import { IdentityProvider, SessionProvider } from "@zapier/identity";

import AppLayout from "@/components/AppLayout";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <IdentityProvider>
      <SessionProvider>
        <AppLayout>{children}</AppLayout>
      </SessionProvider>
    </IdentityProvider>
  );
}
